// extracted by mini-css-extract-plugin
export default {"tooltip":"Sp-z","sharingV2":"Tp-z","sharingIconsV2":"Up-z","links":"Vp-z","link":"Wp-z","facebookV2":"Xp-z","twitterV2":"Yp-z","pinterestV2":"Zp-z"};